import { render } from "./CatalogSelect.vue?vue&type=template&id=e8feca20&ts=true"
import script from "./CatalogSelect.vue?vue&type=script&lang=ts"
export * from "./CatalogSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__